import AuthEndpoints from '@/modules/login/api/authEndpoints'

export const authEndpoints = new AuthEndpoints()
